import escapeRegex from './escapeRegex';
import replaceTrToEn from './replaceTrToEn';

const makeBold = (item: string, keyword: string) => {
  try {
    const escapedKeyword = escapeRegex(keyword);
    const re = RegExp(replaceTrToEn(escapedKeyword), 'gi');
    return item
      .split(' ')
      .map((str) => {
        if (replaceTrToEn(str).match(re)) return `<b>${str}</b>`;
        return str;
      })
      .join(' ');
  } catch (error) {
    return item;
  }
};
export default makeBold;
